(function(){
     'use strict';

     angular
        .module('notification')
        .factory('NotificationService', NotificationService);

    NotificationService.$inject = ['$http'];

    function NotificationService($http){
    	var notification = {};

    	notification.data = function()
    	{
    		return $http.get('/backend/altcrm/site/notification').then(function(data)
    		{
    			return data.data;
    		});
    	}




    	return notification;
    }

})();